import { Environment as r } from "./environment.es.js";
const t = r.env === "development" || r.env === "staging" || !!globalThis.__CI__, n = (o, e) => {
  t && console[o](...e);
}, g = {
  /**
   * Logs informational messages to the console when in debug mode. Only outputs in development, staging, or CI
   * environments.
   *
   * @param args - These arguments are passed directly to console.log
   */
  log(...o) {
    n("log", o);
  },
  /**
   * Logs warning messages to the console when in debug mode. Only outputs in development, staging, or CI environments.
   *
   * @param args - These arguments are passed directly to console.warn
   */
  warn(...o) {
    n("warn", o);
  },
  /**
   * Logs error messages to the console when in debug mode. Only outputs in development, staging, or CI environments.
   *
   * @param args - These arguments are passed directly to console.error
   */
  error(...o) {
    n("error", o);
  }
};
export {
  g as Debug
};
